import {VStack} from 'platform/foundation';

import {PersonnelOverviewItem} from '@dms/api/core';

import {sortByAsciiNumberLast, suffixTestId, TestIdProps} from 'shared/web';

import {getUserName} from '../../../utils/getUserName';
import {PersonnelOverviewListItem} from './PersonnelOverviewListItem';

interface PersonnelOverviewListProps extends TestIdProps {
  items: PersonnelOverviewItem[];
  selectedUserIds: string[];
  onUserSelect: (userId: string) => void;
}

const getItemLabel = (item: PersonnelOverviewItem) =>
  (getUserName(item.user, {reverse: true}) ?? '').trim();

export function PersonnelOverviewList(props: PersonnelOverviewListProps) {
  const sortedItems = [...props.items].sort((a, b) =>
    sortByAsciiNumberLast(getItemLabel(a), getItemLabel(b))
  );

  return (
    <VStack spacing={1} data-testid={suffixTestId('personnelOverviewList', props)}>
      {sortedItems.map((item) => (
        <PersonnelOverviewListItem
          key={item.user.id}
          userId={item.user.id}
          firstName={item.user.firstName}
          lastName={item.user.lastName}
          activeCount={item.activeCount}
          isSelected={props.selectedUserIds.includes(item.user.id)}
          onClick={props.onUserSelect}
          data-testid={suffixTestId(`item-${item.user.id}`, props)}
        />
      ))}
    </VStack>
  );
}
